module.exports = __webpack_public_path__ + "img/014-marshmallow.5df6c436.png";